import makeHead from 'components/Table/Head' 

const LessonsHead = makeHead([
  { id: 'name', align: 'left', disablePadding: false},
  // { id: 'progress', align: 'center', disablePadding: false},
  { id: 'date', align: 'left', disablePadding: true}
],({styles}) => ({...styles}))

export {LessonsHead as default}
